"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricePerSquareFootProperty$ = exports.PricePerSquareFootProperty$outboundSchema = exports.PricePerSquareFootProperty$inboundSchema = void 0;
exports.pricePerSquareFootPropertyToJSON = pricePerSquareFootPropertyToJSON;
exports.pricePerSquareFootPropertyFromJSON = pricePerSquareFootPropertyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statspropertytype_js_1 = require("./statspropertytype.js");
/** @internal */
exports.PricePerSquareFootProperty$inboundSchema = z.object({
    average_price_per_square_foot: z.number(),
    property_type: statspropertytype_js_1.StatsPropertyType$inboundSchema,
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_price_per_square_foot": "averagePricePerSquareFoot",
        "property_type": "propertyType",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.PricePerSquareFootProperty$outboundSchema = z.object({
    averagePricePerSquareFoot: z.number(),
    propertyType: statspropertytype_js_1.StatsPropertyType$outboundSchema,
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averagePricePerSquareFoot: "average_price_per_square_foot",
        propertyType: "property_type",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PricePerSquareFootProperty$;
(function (PricePerSquareFootProperty$) {
    /** @deprecated use `PricePerSquareFootProperty$inboundSchema` instead. */
    PricePerSquareFootProperty$.inboundSchema = exports.PricePerSquareFootProperty$inboundSchema;
    /** @deprecated use `PricePerSquareFootProperty$outboundSchema` instead. */
    PricePerSquareFootProperty$.outboundSchema = exports.PricePerSquareFootProperty$outboundSchema;
})(PricePerSquareFootProperty$ || (exports.PricePerSquareFootProperty$ = PricePerSquareFootProperty$ = {}));
function pricePerSquareFootPropertyToJSON(pricePerSquareFootProperty) {
    return JSON.stringify(exports.PricePerSquareFootProperty$outboundSchema.parse(pricePerSquareFootProperty));
}
function pricePerSquareFootPropertyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PricePerSquareFootProperty$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PricePerSquareFootProperty' from JSON`);
}
//# sourceMappingURL=pricepersquarefootproperty.js.map